<template>
  <div class="settings-btn rtl-btn">
    <a
      href="https://wa.me/447429916178"
      target="_blank"
      rel="noopener noreferrer"
      class="whatsapp-btn"
      aria-label="WhatsApp"
    >
      <i class="ri-whatsapp-fill"></i>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "WhatsappBtn",
});
</script>

<style scoped>
.whatsapp-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  text-decoration: none;
  font-size: 26px;
  color: #fff;
  background: #25d366;
  transition: 0.3s;
}

.whatsapp-btn:hover {
  transform: scale(1.1);
}
</style>